import { ARCHIVED_DOCU_REQUEST, ARCHIVED_DOCU_ERROR, ARCHIVED_DOCU_SUCCESS } from '../actions/archivedDocu'
import apiCall from '@/utils/api'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'
import axios from 'axios'

const state = { status: '', archivedDocuments: {} }

const getters = {
  getArchivedDocuments: state => state.archivedDocuments,
}

const actions = {
  [ARCHIVED_DOCU_REQUEST]: ({commit, dispatch}) => {
    console.log("Start archived docu request");
    commit(ARCHIVED_DOCU_REQUEST)

      const headers = {
        'Accept': 'application/json;charset=UTF-8'
      };

    axios({url:  'members/io/downloads/directories/archive/', headers, method: 'GET'})
      .then(resp => {
        commit(ARCHIVED_DOCU_SUCCESS, resp.data)
      })
      .catch(resp => {
      console.log("archied docu request error");
        commit(ARCHIVED_DOCU_ERROR)
        // if resp is unauthorized, logout, to
        // TODO: really logout?
        //dispatch(AUTH_LOGOUT)
      })
  },
}

const mutations = {
  [ARCHIVED_DOCU_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [ARCHIVED_DOCU_SUCCESS]: (state, docs) => {
    state.status = 'success'
    //Vue.set(state, 'documents', resp.data)
    state.archivedDocuments = docs
  },
  [ARCHIVED_DOCU_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.archivedDocuments = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
